import { TemplateResult, html, unsafeCSS } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { ScopedRegistryHost } from '@lit-labs/scoped-registry-mixin';
import { LeafElement } from '@cigna/dcws_leaf-web-components/components/leaf-element.js';
import { LeafButton } from '@cigna/dcws_leaf-web-components/components/button/button.component.js';
import { LeafInput } from '@cigna/dcws_leaf-web-components/components/input/input.component.js';
import { LeafLabel } from '@cigna/dcws_leaf-web-components/components/label/label.component.js';
import { LeafSelect } from '@cigna/dcws_leaf-web-components/components/select/select.component.js';
import { LeafSelectOption } from '@cigna/dcws_leaf-web-components/components/select-option/select-option.component.js';
import { LeafValidationMessage } from '@cigna/dcws_leaf-web-components/components/validation-message/validation-message.component.js';
import { LeafSpinner } from '@cigna/dcws_leaf-web-components/components/spinner/spinner.component.js';
import { CHCMedicarePlanFinder } from '../medicare-plan-finder/medicare-plan-finder.component.js';
import { addSubmitHandler } from '../url-select-form/service.js';
import styles from './shop-plans-banner.scss?inline';

export class CHCHomepageBanner extends ScopedRegistryHost(LeafElement) {
  static override styles = unsafeCSS(styles);
  static elementDefinitions = {
    'leaf-button': LeafButton,
    'leaf-input': LeafInput,
    'leaf-label': LeafLabel,
    'leaf-select': LeafSelect,
    'leaf-select-option': LeafSelectOption,
    'leaf-spinner': LeafSpinner,
    'leaf-validation-message': LeafValidationMessage,
    'chcapp-medicare-plan-finder': CHCMedicarePlanFinder,
  };

  @property()
  label: string = '';

  @property()
  button: string = '';

  @property()
  selected: string | undefined;

  @property({ type: Object })
  data: {
    [key: string]: string;
  } = {};

  @state()
  showPlanFinder = false;

  @query('[data-url-select]')
  _urlForm!: HTMLFormElement;

  protected override async firstUpdated() {
    await this.updateComplete;
    this.showPlanFinder = this.selected === 'plan-finder';
    addSubmitHandler(this._urlForm);
  }

  handleSelectChange = (event: InputEvent) => {
    const select = event.target as unknown as LeafSelect;
    this.showPlanFinder = select?.value === 'plan-finder';
  };

  renderSelectOptions(): TemplateResult {
    const renderHTML = [];
    for (const [key, value] of Object.entries(this.data)) {
      renderHTML.push(
        html`<leaf-select-option ?selected=${this.selected && this.selected === key} value=${key}
          >${value}</leaf-select-option
        >`,
      );
    }
    return html`${renderHTML}`;
  }

  renderMedicarePlanFinder(): TemplateResult {
    return this.showPlanFinder
      ? html` <chcapp-medicare-plan-finder variant="basic"> </chcapp-medicare-plan-finder> `
      : html``;
  }

  override render() {
    const componentClassName = {
      'chcapp-shop-plans-banner': true,
      'chcapp-shop-plans-banner--plan-finder': this.showPlanFinder,
    };

    return html`<div class=${classMap(componentClassName)}>
      <form data-url-select="true" method="post">
        <div>
          <leaf-label for="coveragetype">${this.label}</leaf-label>
          <leaf-select
            autocomplete="coveragetype"
            name="coveragetype"
            id="coveragetype"
            required="true"
            @change=${this.handleSelectChange}
          >
            ${this.renderSelectOptions()}
          </leaf-select>
        </div>
        <leaf-button variant="primary" type="submit">${this.button}</leaf-button>
      </form>
      ${this.renderMedicarePlanFinder()}
    </div> `;
  }
}
